export const getCurrentTime = () => {
  return new Date().getTime();
}
